import { useState } from 'react';
import { homeFAQ } from '@/mocks/faq';
import { Link } from 'react-router-dom';

export default function HomeFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="w-full min-h-screen flex flex-col justify-center py-20 md:py-28 bg-gradient-to-br from-primary-50 via-primary-100/60 to-secondary-100">
      <div className="w-full px-6 md:px-10 max-w-[1200px] mx-auto">
        <div className="text-center mb-14 md:mb-18">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-4">
            常見問題
          </h2>
          <p className="text-sm text-foreground-600">
            關於清文華泉，你可能想知道的幾件事。
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {homeFAQ.map((item, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {item.question}
                </span>
                <div className={`w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full transition-colors duration-300 ${
                  openIndex === index ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-500'
                }`}>
                  <i className={`text-sm transition-transform duration-300 ${openIndex === index ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-5 md:pb-6 px-5 md:px-6' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/faq"
            className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            瀏覽完整常見問題
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}